import { useStyles } from './my-lenses-not-fitted-content.styles';
import { CardPlaceholder } from './card-placeholder';
import { DiscountBanner } from './discount-banner';

export const MyLensesNotFittedContent = (): JSX.Element => {
  const classes = useStyles();

  return (
    <div data-testid="my-lenses-not-fitted">
      <div data-testid="banner-wrapper">
        <DiscountBanner />
      </div>
      <div className={classes.cardPlaceholderWrapper}>
        <CardPlaceholder />
      </div>
    </div>
  );
};
